module.exports = __webpack_public_path__ + "img/20f2.6f0d4131.jpg";